import * as filestack from 'filestack-js'

const filestackClient = filestack.init(
  bzGlobal.applicationConstants.filepicker.key
)

export default filestackClient
